<template>
  <router-view/>
</template>

<style lang="scss">
@import './scss/config.scss';
@import './scss/utilities.scss';





</style>
